<template>
  <div class="container">
    <!-- Filtlro -->
    <v-form ref="form">
      <p>Buscar Por:</p>
      <v-row class="justify-start mt-3 ml-3">
        <v-col :cols="12" >
          <v-autocomplete
              v-model="form.filters.gre"
              label="GRE"
              dense
              outlined
              item-text="nome"
              item-value="codigo"
              return-object
              :items="form.listaGerenciasRegionais"
              @change="atualizarGreIds"
          />
        </v-col>
        <v-col :cols="12" >
          <v-autocomplete
              v-model="form.filters.escola"
              label="Escola"
              dense
              outlined
              item-text="nome"
              item-value="codigo"
              return-object
              :disabled="!form.filters.gre"
              :items="form.listaEscolas"
          />
        </v-col>
      </v-row>
      <v-row class="btn-group">
        <v-col class="text-end">
          <v-btn
              color="primary"
              @click="resetForm"
              outlined
          >
            Limpar
          </v-btn>
          <v-btn
              color="primary"
              @click="buscarDashboard"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <!-- Dashboard Escola Unica -->
    <div class="mt-7">
        <DashboardFormacaoEscolaUnica
                v-if="dashboardEscolaUnica"
                :dashboardEscolaUnica="dashboardEscolaUnica"
                :key="dashboardEscolaUnica?.id || dashboardEscolaUnica?.codigo || JSON.stringify(dashboardEscolaUnica)"
              />
    </div>

    <!-- Dashboard Escolas -->
    <div v-if="dashboardEscolas != null" class="mt-7">
      <div v-if="!dashboardEscolaUnica">
      <!-- Cards -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Escolas</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboardEscolas?.info?.escolas ?? 0}}</div>
              <v-icon large color="blue">mdi-bank</v-icon>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Escolas com Formações</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboardEscolas?.info?.escolasComFormacoes ?? 0}}</div>
              <v-icon large color="blue">mdi-bank</v-icon>
            </div>
            <v-btn outlined small color="blue" @click="openDialogListarEscolasComFormacao">Visualizar Listagem</v-btn>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Formações Realizadas</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboardEscolas?.info?.formacoesRealizadas ?? 0}}</div>
              <v-icon large color="green">mdi-checkbox-marked-outline</v-icon>
            </div>
            <v-btn outlined small color="green" @click="openDialogListarFormacoesEscolas">Visualizar Listagem</v-btn>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Participantes</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboardEscolas?.info?.participantes ?? 0}}</div>
              <v-icon large color="blue">mdi-account-group-outline</v-icon>
            </div>
            <v-btn outlined small color="blue" @click="openDialogListarParticipantesEscolas">Visualizar Listagem</v-btn>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Participação</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboardEscolas?.info?.participacao ?? 0}} %</div>
              <v-icon large color="green">mdi-chart-pie</v-icon>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Gráficos -->
      <v-row>
        <v-col cols="12" md="12" class="fill-height" style="height: 500px;">
          <v-card class="pa-4 text-center fill-height" style="height: 100%;">
            <div class="mb-4 text-start">Formações em Escolas</div>
            <PieChart :chartData="dataPizza"/>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12" class="fill-height" v-if="stackedChartData.length > 0">
          <v-card class="pa-4 text-center fill-height" style="height: 100%">
          <HorizontalBarStackedChart v-if="stackedChartData" :rawData="stackedChartData" :height="stackedChartHeight" />
          <p v-else style="color: #333;">Não há dados!</p>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="btn-group">
        <v-col class="text-end">
          <v-btn
              color="primary"
              @click="exportarDadosPdf"
              outlined
          >
            Exportar Gráficos
          </v-btn>
        </v-col>
      </v-row>
     </div>
    </div>

    <!-- Dialogs -->
    <ListarEscolasComFormacaoDialog
        v-if="dialogListarEscolasComFormacaoDialog.visible"
        :visible="dialogListarEscolasComFormacaoDialog.visible"
        :content="dialogListarEscolasComFormacaoDialog.content"
        @onClose="dialogListarEscolasComFormacaoDialog.close()"
    ></ListarEscolasComFormacaoDialog>

    <ListarFormacoesEscolasDialog
        v-if="dialogListarFormacoesEscolas.visible"
        :visible="dialogListarFormacoesEscolas.visible"
        :content="dialogListarFormacoesEscolas.content"
        @onClose="dialogListarFormacoesEscolas.close()"
    ></ListarFormacoesEscolasDialog>
    <ListarParticipantesEscolasDialog
        v-if="dialogListarParticipantesEscolas.visible"
        :visible="dialogListarParticipantesEscolas.visible"
        :content="dialogListarParticipantesEscolas.content"
        @onClose="dialogListarParticipantesEscolas.close()"
    ></ListarParticipantesEscolasDialog>


  </div>
</template>

<script>
import {Dialog} from "commons/classes/dialog";
import DashboardFormacaoService from "services/dashboard-formacao.service";
import AuthService from "services/auth.service";
import ListarEscolasComFormacaoDialog from "views/post-login/administrador/manter-dashboard-formacao/dialogs/Escolas/ListarEscolasComFormacaoDialog.vue";
import ListarFormacoesEscolasDialog from "views/post-login/administrador/manter-dashboard-formacao/dialogs/Escolas/ListarFormacoesEscolasDialog.vue";
import ListarParticipantesEscolasDialog from "views/post-login/administrador/manter-dashboard-formacao/dialogs/Escolas/ListarParticipantesEscolasDialog.vue";
import {Dashboard} from "commons/classes/dashboard";

export default {
  name: "ManterDashboardFormacaoEscolasView",
  mixins: [DashboardFormacaoService, AuthService],
  components: {
    DashboardFormacaoEscolaUnica: () => import('./ManterDashboardFormacaoEscolaUnicaView.vue'),
    PieChart: () => import('@/components/Graficos/PieChart.vue'),
    HorizontalBarStackedChart: () => import('@/components/Graficos/HorizontalBarStackedChart'),
    //Dialogs
    ListarEscolasComFormacaoDialog,
    ListarFormacoesEscolasDialog,
    ListarParticipantesEscolasDialog
  },
  data: () => ({
    dialogListarEscolasComFormacaoDialog: Dialog.Build(),
    dialogListarFormacoesEscolas: Dialog.Build(),
    dialogListarParticipantesEscolas: Dialog.Build(),
    dashboardEscolas: null,
    dashboardEscolaUnica: null,
    dataPizza: {
      labels: ['Formações', 'Escolas'],
      datasets: [
        {
          data: [1, 1],
          backgroundColor: ['#4CAF50','#3F51B5', ]
        }
      ]
    },
    stackedChartData: [],
    form:{
      filters: {
        gre: null,
        escola: null,
      },
      listaEscolas: [],
      listaGerenciasRegionais: [],
    },
  }),
  methods: {
    buscarDashboard(){
      this.dashboardEscolas = null;
      this.dashboardEscolaUnica = null;
      if(this.form.filters?.escola)
        this.buscarDashboardEscolaUnica();
      else
        this.buscarDashboardEscolas();
    },
    buscarDashboardEscolas() {
      this.$buscarDashboardEscolas({ params: {
        greCodigo: this.form.filters.gre?.codigo,
        escolaCodigo: this.form.filters.escola?.codigo
      } }).then(
          ({ data }) => {
            this.dashboardEscolas = data.dashboard
            this.dataPizza.datasets[0].data = data?.dashboard?.grafico?.dataPizza;
            this.stackedChartData = data?.dashboard?.grafico?.stackedChartData || [];
          }
      )
    },
    buscarDashboardEscolaUnica() {
      this.$buscarDashboardEscolaUnica({ params: {
        escolaCodigo: this.form.filters.escola?.codigo,
        greCodigo: this.form.filters.gre?.codigo
      } }).then(
          ({ data }) => {
            this.dashboardEscolaUnica = data.dashboard
          }
      )
    },
    openDialogListarEscolasComFormacao() {
      this.dialogListarEscolasComFormacaoDialog.open(new Dashboard({id: this.dashboardEscolas?.greCodigo, origemId: 3}));
    },
    openDialogListarFormacoesEscolas() {
      this.dialogListarFormacoesEscolas.open(new Dashboard({id: this.dashboardEscolas?.greCodigo, origemId: 3}));
    },
    openDialogListarParticipantesEscolas() {
      this.dialogListarParticipantesEscolas.open(new Dashboard({id: this.dashboardEscolas?.greCodigo, origemId: 3}));
    },
    resetForm() {
      this.$resetForm();
      this.dashboardEscolas = null;
      this.dashboardEscolaUnica = null;
    },
    atualizarGreIds() {
      this.form.filters.escola = null;
      if (this.form.filters.gre) {
        this.consultandoEscolasViaGre();
      } else {
        this.form.listaEscolas = [];
      }
      
    },
    consultandoEscolasViaGre() {
      this.$obterListaEscolas({ gres: this.form.filters.gre?.codigo })
        .then(({ data }) => {
          this.form.listaEscolas = data.lista;
        }
      );
    },
    async exportarDadosPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardEscolasPdf(this.$montarParamsFilters(
            {greCodigo: this.form.filters.gre?.codigo}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.FormacoesEscolas.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  computed: {
    stackedChartHeight() {
      return this.stackedChartData?.length > 5 ? 650 : 400;
    }
  },
  mounted() {
    this.$obterListaGerenciasRegionais().then(({ data }) => {
      this.form.listaGerenciasRegionais = data.lista;
    });
  },
}
</script>